"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
var vue_1 = require("vue");
var _withScopeId = function (n) { return (vue_1.pushScopeId("data-v-316b94e5"), n = n(), vue_1.popScopeId(), n); };
var _hoisted_1 = { class: "message-file" };
var _hoisted_2 = ["title"];
var _hoisted_3 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return vue_1.createElementVNode("i", { class: "icon icon-files" }, null, -1); });
var _hoisted_4 = { class: "message-file-content" };
var _hoisted_5 = ["value"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (vue_1.openBlock(), vue_1.createElementBlock("div", _hoisted_1, [
        vue_1.createElementVNode("div", {
            class: "box",
            onClick: _cache[0] || (_cache[0] =
                //@ts-ignore
                function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    return (_ctx.download && _ctx.download.apply(_ctx, args));
                }),
            title: _ctx.$t('TUIChat.单击下载')
        }, [
            _hoisted_3,
            vue_1.createElementVNode("div", _hoisted_4, [
                vue_1.createElementVNode("label", null, vue_1.toDisplayString(_ctx.data.name), 1),
                vue_1.createElementVNode("span", null, vue_1.toDisplayString(_ctx.data.size), 1)
            ])
        ], 8, _hoisted_2),
        (_ctx.data.progress)
            ? (vue_1.openBlock(), vue_1.createElementBlock("progress", {
                key: 0,
                value: _ctx.data.progress,
                max: "1"
            }, null, 8, _hoisted_5))
            : vue_1.createCommentVNode("", true)
    ]));
}
exports.render = render;
